<div class="loading-screen-wrapper" [ngStyle]="display">
    <div class="loading-screen-icon">
        <div class="loader"></div>
    </div>
</div>
